// @flow
import React from 'react';

import Embedtwitch from 'components/embedTwitch';
import { Component } from 'components/newsletter/blocs/HtmlElementWrapper';
import HTMLGallery from 'components/newsletter/blocs/HTMLGallery/HTMLGallery';
import AlbumGallery from 'containers/fragments/AlbumGalleryContainer';
import HTMLAccordion from 'components/newsletter/blocs/HTMLAccordion/HTMLAccordion';
import Countdown from 'components/newsletter/blocs/CountDown';
import OpenStreetMap from 'components/fragments/map/OpenStreetMap';
import HtmlScript from 'components/newsletter/blocs/HtmlScript';
import Download from 'components/fragments/Download';
import CardMap from 'components/fragments/card/CardMap';
import Annuaire from 'components/fragments/Annuaire';
import { blacklist } from 'constants/newsletterBlocConstants';
import { FB_API_KEY } from 'constants/app.js';
import FacebookProvider, { EmbeddedPost } from 'react-facebook-sdk';
import { socialNetworks } from 'utils/socialShareUtils';

const ContentBloc = (props: any) => {
  const { attributes, children, tagName } = props;
  if (tagName === 'embed-twitch') {
    return <Embedtwitch attributes={attributes} />;
  }
  if (tagName === 'gallery' && children) {
    const galleryAttributes = attributes ? attributes : [];
    return <HTMLGallery childrens={children} attributes={galleryAttributes} tagName={tagName} />;
  }
  if (
    (tagName === 'figure' && children && children.length > 0 && children[0].tagName === 'galleryalbum') ||
    tagName === 'galleryalbum'
  ) {
    let content = !!children && !!children.length ? children[0] : [];
    if (content.tagName === 'gallery-item-wp-593') {
      content = { children };
    }

    return <AlbumGallery content={content} />;
  }
  if (tagName === 'annuaire') {
    if (attributes[0].name === 'data-annuaire') {
      const annuaire = JSON.parse(attributes[0].value.replace(/\s:/g, ':'));
      return <Annuaire annuaire={annuaire} />;
    }
    if (attributes[0].name === 'type') {
      const annuaire = JSON.parse(attributes[1].value.replace(/\s:/g, ':'));
      return <Annuaire type={attributes[0].value} annuaire={annuaire} />;
    }
  }
  if (tagName === 'countdown') {
    return (
      <Countdown
        date={attributes[0] && attributes[0].value ? attributes[0].value : new Date().toString()}
        message={attributes[1] && attributes[1].value ? attributes[1].value : ''}
      />
    );
  }
  if (tagName === 'carte-geojson') {
    if (attributes.length > 0 && attributes[0].name === 'src') {
      return (
        <OpenStreetMap
          geojson={attributes[0].value}
          height={'450'}
          geolocation={false}
          classNames={'carte--centenaire'}
          long={0}
          lat={0}
          zoom={3}
        />
      );
    }
  }
  if (tagName === 'accordeon') {
    return <HTMLAccordion childrens={children} attributes={attributes} tagName={tagName} />;
  }
  if (tagName === 'download') {
    const attrs = {};
    attributes.forEach(function(attr, index) {
      attrs[attr.name] = attr.value;
    });
    return <Download {...attrs} />;
  }
  if (tagName === 'openstreetmap' && attributes) {
    const cardProps = attributes.reduce((acc, { name, value }) => {
      acc[name] = value;
      return acc;
    }, {});

    return <CardMap {...cardProps} />;
  }
  if (tagName === 'facebook') {
    const attr = props.attributes.find(attr => attr.name === 'cite');
    if (attr) {
      return (
        <FacebookProvider appId={FB_API_KEY}>
          <EmbeddedPost href={attr.value} />
        </FacebookProvider>
      );
    }
  }

  /**
   * Liste de boutons sociaux, cf : https://ffr-site-comites.netlify.app/partenaires-projets.html
   */
  if (tagName === 'socialshare') {
    const propsSocial =
      attributes && attributes.length > 0 ? JSON.parse(attributes[0].value) : { title: false, link: false };

    if (propsSocial && propsSocial.link) {
      // $FlowFixMe
      return Object.keys(socialNetworks).map(key => {
        const ShareButton = socialNetworks[key];
        const classNames =
          key === 'mail'
            ? 'btn btn--social btn--small btn--primary btn--medium'
            : `btn btn--social btn--small btn--${key} btn--medium`;
        const dataButton: any = { url: propsSocial.link, role: 'button', tabIndex: 0 };
        // let title = '';
        if (key === 'facebook') {
          dataButton.quote = propsSocial.title;
          dataButton.style = { backgroundColor: '#385595', color: 'white' };
          // title = dataButton.quote;
        } else if (key === 'twitter') {
          dataButton.title = propsSocial.title;
          dataButton.style = { backgroundColor: '#4eaaf3', color: 'white' };
          // title = dataButton.title;
        } else if (key === 'whatsapp') {
          dataButton.title = propsSocial.title;
          dataButton.style = { backgroundColor: '#24d166', color: 'white' };
          // title = dataButton.title;
        } else if (key === 'linkedin') {
          dataButton.subject = propsSocial.title;
          dataButton.style = { backgroundColor: '#0075b3', color: 'white' };
          // title = dataButton.subject;
        } else if (key === 'mail') {
          dataButton.subject = propsSocial.title;
          dataButton.style = { backgroundColor: '#c75d37', color: 'white' };
          // title = dataButton.subject;
        }

        return (
          <ShareButton className={classNames} {...dataButton} key={`${key}-share-button`}>
            <i className={`icon icon-${key}`} />
          </ShareButton>
        );
      });
    }
  }

  if (!blacklist.includes(tagName)) {
    return <Component childrens={children} attributes={attributes} tagName={tagName} />;
  } else {
    return <HtmlScript childrens={children} attributes={attributes} tagName={tagName} />;
  }
};

export default ContentBloc;
